import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="container email-login clearfix">
  <div class="content-wrapper">
    <div class="image-wrapper">
      <img src={{this.lockImageUrl}} class="password-reset-img" alt="" />
    </div>

    <form>
      {{#if this.model.error}}
        <div class="error-info">
          {{html-safe this.model.error}}
        </div>
      {{/if}}

      {{#if this.model.can_login}}
        <div class="email-login-form">
          {{#if this.secondFactorRequired}}
            {{#if this.model.security_key_required}}
              <SecurityKeyForm
                @allowedCredentialIds={{this.model.allowed_credential_ids}}
                @challenge={{this.model.security_key_challenge}}
                @showSecurityKey={{this.model.security_key_required}}
                @showSecondFactor={{false}}
                @secondFactorMethod={{this.secondFactorMethod}}
                @otherMethodAllowed={{this.secondFactorRequired}}
                @action={{action "authenticateSecurityKey"}}
              />
            {{else}}
              <SecondFactorForm
                @secondFactorMethod={{this.secondFactorMethod}}
                @secondFactorToken={{this.secondFactorToken}}
                @backupEnabled={{this.model.backup_codes_enabled}}
                @isLogin={{true}}
              >
                <SecondFactorInput
                  {{on
                    "input"
                    (with-event-value (fn (mut this.secondFactorToken)))
                  }}
                  @secondFactorMethod={{this.secondFactorMethod}}
                  value={{this.secondFactorToken}}
                />
              </SecondFactorForm>
            {{/if}}
          {{else}}
            <h2>{{i18n
                "email_login.confirm_title"
                site_name=this.siteSettings.title
              }}</h2>
            <p>{{i18n
                "email_login.logging_in_as"
                email=this.model.token_email
              }}</p>
          {{/if}}

          {{#unless this.model.security_key_required}}
            <DButton
              @label="email_login.confirm_button"
              @action={{action "finishLogin"}}
              type="submit"
              class="btn-primary"
            />
          {{/unless}}
        </div>
      {{/if}}
    </form>
  </div>
</div>
*/
{
  "id": "0p0mOC5s",
  "block": "[[[10,0],[14,0,\"container email-login clearfix\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"content-wrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"image-wrapper\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"src\",[30,0,[\"lockImageUrl\"]]],[14,0,\"password-reset-img\"],[14,\"alt\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"form\"],[12],[1,\"\\n\"],[41,[30,0,[\"model\",\"error\"]],[[[1,\"        \"],[10,0],[14,0,\"error-info\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,0,[\"model\",\"error\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"model\",\"can_login\"]],[[[1,\"        \"],[10,0],[14,0,\"email-login-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"secondFactorRequired\"]],[[[41,[30,0,[\"model\",\"security_key_required\"]],[[[1,\"              \"],[8,[39,2],null,[[\"@allowedCredentialIds\",\"@challenge\",\"@showSecurityKey\",\"@showSecondFactor\",\"@secondFactorMethod\",\"@otherMethodAllowed\",\"@action\"],[[30,0,[\"model\",\"allowed_credential_ids\"]],[30,0,[\"model\",\"security_key_challenge\"]],[30,0,[\"model\",\"security_key_required\"]],false,[30,0,[\"secondFactorMethod\"]],[30,0,[\"secondFactorRequired\"]],[28,[37,3],[[30,0],\"authenticateSecurityKey\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,4],null,[[\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@isLogin\"],[[30,0,[\"secondFactorMethod\"]],[30,0,[\"secondFactorToken\"]],[30,0,[\"model\",\"backup_codes_enabled\"]],true]],[[\"default\"],[[[[1,\"\\n                \"],[8,[39,5],[[16,2,[30,0,[\"secondFactorToken\"]]],[4,[38,6],[\"input\",[28,[37,7],[[28,[37,8],[[28,[37,9],[[30,0,[\"secondFactorToken\"]]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,0,[\"secondFactorMethod\"]]]],null],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],[[[1,\"            \"],[10,\"h2\"],[12],[1,[28,[35,10],[\"email_login.confirm_title\"],[[\"site_name\"],[[30,0,[\"siteSettings\",\"title\"]]]]]],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,10],[\"email_login.logging_in_as\"],[[\"email\"],[[30,0,[\"model\",\"token_email\"]]]]]],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[51,[30,0,[\"model\",\"security_key_required\"]]],[[[1,\"            \"],[8,[39,12],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@label\",\"@action\"],[\"email_login.confirm_button\",[28,[37,3],[[30,0],\"finishLogin\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"if\",\"html-safe\",\"security-key-form\",\"action\",\"second-factor-form\",\"second-factor-input\",\"on\",\"with-event-value\",\"fn\",\"mut\",\"i18n\",\"unless\",\"d-button\"]]",
  "moduleName": "discourse/templates/email-login.hbs",
  "isStrictMode": false
});